import { Button, Typography } from "@mui/material";
import { StyledStackContainer } from "./styles";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
}


const Pagination = ({ currentPage, totalPages, setCurrentPage }: PaginationProps) => {
  return (
    <StyledStackContainer >
      <Button variant="outlined" size="small" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
        Anterior
      </Button>

      <Typography>
        Página {currentPage} de {totalPages}
      </Typography>

      <Button variant="outlined" size="small" disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
        Próximo
      </Button>
    </StyledStackContainer>
  );
};

export default Pagination;
